import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  DatePicker,
  TimePicker,
  Button,
  Dropdown,
  Space,
  Row,
  Col,
} from "antd";
import { DownOutlined } from "@ant-design/icons";
import {
  setStartDate,
  setEndDate,
  setStartTime,
  setEndTime,
  setDashboardClicked,
  resetFilters,
} from "../../redux/slices/filtersSlice";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

function DashboardFilterDropDown() {
  const dispatch = useDispatch();
  const { startDate, endDate, startTime, endTime, dashboardClicked } =
    useSelector((state) => state.filters);

  const [openDropDown, setOpenDropDown] = React.useState(false);

  const handleOpenDropDown = () => setOpenDropDown(!openDropDown);

  const handleDateChange = (key, value) => {
    const formattedDate = value ? dayjs(value).format("YYYY-MM-DD") : "";
    if (key === "startDate") dispatch(setStartDate(formattedDate));
    if (key === "endDate") dispatch(setEndDate(formattedDate));
  };

  const handleTimeChange = async (key, value) => {
    const formattedTime = value ? dayjs(value).format("HH:mm:ss") : "";
    if (key === "startTime") dispatch(setStartTime(formattedTime));
    if (key === "endTime") dispatch(setEndTime(formattedTime));
  };

  const items = [
    {
      label: (
        <div>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <DatePicker
                allowClear={false}
                format="YYYY-MM-DD"
                value={dayjs(startDate)}
                onChange={(date) => handleDateChange("startDate", date)}
                placeholder="Start Date"
                className="w-full"
              />
            </Col>
            <Col span={12}>
              <DatePicker
                allowClear={false}
                format="YYYY-MM-DD"
                value={dayjs(endDate)}
                onChange={(date) => handleDateChange("endDate", date)}
                placeholder="End Date"
                className="w-full"
              />
            </Col>
          </Row>
        </div>
      ),
      key: "0",
    },
    {
      label: (
        <div>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <TimePicker
                allowClear={false}
                value={dayjs(`1970-01-01T${startTime}`)}
                onChange={(time) => handleTimeChange("startTime", time)}
                placeholder="Start Time"
                className="w-full"
                format="HH:mm:ss"
              />
            </Col>
            <Col span={12}>
              <TimePicker
                allowClear={false}
                value={dayjs(`1970-01-01T${endTime}`)}
                onChange={(time) => handleTimeChange("endTime", time)}
                placeholder="End Time"
                className="w-full"
                format="HH:mm:ss"
              />
            </Col>
          </Row>
        </div>
      ),
      key: "1",
    },
    {
      type: "divider",
    },
    {
      label: (
        <div className="flex gap-2">
          <Button
            type="primary"
            onClick={() => dispatch(setDashboardClicked(dashboardClicked + 1))}
            className="w-full bg-teal-600 hover:bg-teal-700"
          >
            Get Data
          </Button>
          <Button
            type="default"
            onClick={() => dispatch(resetFilters())}
            className="w-full"
          >
            Reset
          </Button>
        </div>
      ),
      key: "2",
    },
  ];

  return (
    <div className="flex justify-end mb-2">
      <Dropdown menu={{ items }} trigger={["click"]} open={openDropDown}>
        <Button
          className="bg-teal-600 hover:bg-teal-700 text-white flex items-center"
          onClick={handleOpenDropDown}
        >
          <Space>
            Filters
            <DownOutlined />
          </Space>
        </Button>
      </Dropdown>
    </div>
  );
}

export default DashboardFilterDropDown;
